export default __webpack_public_path__ + "static/media/peso-sign-solid-full.db6bb353.svg";